import { z } from 'zod';

export const submitFeedbackSchema = z.object({
  /** Төслийн төрөл (tinyint); заавал биш — илгээгүй бол буцаад 7 ашиглана. */
  projectId: z.coerce
    .number({ error: 'Төслийн ID тоо байх ёстой.' })
    .int()
    .min(1)
    .max(255)
    .optional()
    .default(7),
  companyId: z.coerce
    .number({ error: 'Компанийн ID заавал байна.' })
    .min(1, 'Компанийн ID 0 байж болохгүй.')
    .optional()
    .default(0),
  phone: z.coerce
    .number({ error: 'Утасны дугаар заавал байна.' })
    .int('Утасны дугаар бүхэл тоо байх ёстой')
    .refine((val) => /^\d+$/.test(String(val)), {
      message: 'Утасны дугаар зөвхөн тоон агуулсан байх ёстой',
    })
    .refine((val) => String(val).length >= 8, {
      message: 'Хамгийн багадаа 8 оронтой утасны дугаар оруулна уу',
    })
    .refine((val) => String(val).length <= 8, {
      message: 'Хамгийн ихдээ 8 оронтой утасны дугаар оруулна уу',
    })
    .default(0),
  catId: z.coerce
    .number()
    .int()
    .min(1, 'Санал сэтгэгдлийн төрөл заавал байна.')
    .default(0),
  feedback: z
    .string({ error: 'Санал хүсэлт заавал байна.' })
    .max(500, 'Хамгийн ихдээ 500 тэмдэгт оруулна уу')
    .trim()
    .default(''),
  files: z
    .array(z.string({ error: 'Файлын заавал байна.' }))
    .optional()
    .default([]),
});
export type SubmitFeedbackInput = z.infer<typeof submitFeedbackSchema>;
